import { render, staticRenderFns } from "./svg-graph.vue?vue&type=template&id=01a87fa4&"
import script from "./svg-graph.ts?vue&type=script&lang=js&"
export * from "./svg-graph.ts?vue&type=script&lang=js&"
import style0 from "./svg-graph.vue?vue&type=style&index=0&id=01a87fa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports